<template>
  <div class="block-chain-user">
    <action-bar>
      <btn-style :btn-list="operateBtn"></btn-style>
    </action-bar>
    <card-table
      :item-meta-title="metaTitle"
      :item-meta-data="metaData"
      :table-data="list"
      :operator="operator"
      :paging="paging"
      @pagination="handleSizeOrPageChange"
    >
    </card-table>
    <create-user ref="userDetail" @handleChildMethod="getList"></create-user>

    <download-dialog
      :dialog-visible.sync="showDownloadDialog"
      title="合约下载"
      :file-url="downloadUrl"
      :file-name="downloadFileName"
    ></download-dialog>
  </div>
</template>

<script>
import auth from '@/auth/index'
import { mapState, mapActions } from 'vuex'
import createUser from './createUser'

export default {
  name: 'Index',
  components: {
    createUser
  },
  data() {
    return {
      metaTitle: {
        label: '用户名',
        value: 'name'
      },
      metaData: [
        {
          label: '属性集合',
          value: 'attr',
          formatter: row => {
            return row.attr && row.attr.length > 0 ? row.attr.join('，') : ''
          }
        },
        {
          label: '注册时间',
          value: 'create_time'
        }
      ],
      operateBtn: [
        {
          btnContent: '新建',
          icon: 'icon-add',
          click: () => {
            return this.createData()
          },
          auth: auth.blockchain.checkDetail.userManage.create
        },
        {
          btnContent: '合约下载',
          icon: 'icon-download',
          click: () => {
            return this.contractDown()
          },
          auth: auth.blockchain.checkDetail.userManage.downloadContract
        }
      ],
      inputContent: '',
      // table的基本操作
      operator: [
        {
          text: '使用',
          showText: true,
          click: (row, col, cellValue) => {
            return this.handleChecked(row, col, cellValue)
          },
          icon: 'icon-use',
          judgeShow: (data, ele) => {
            const userID = JSON.parse(localStorage.getItem('userID'))
            return data.id != userID
          }
        },
        {
          text: '使用中',
          showText: true,
          click: (row, col, cellValue) => {
            this.$message.success('当前用户使用中！')
          },
          icon: 'icon-use',
          judgeShow: (data, ele) => {
            const userID = JSON.parse(localStorage.getItem('userID'))
            return data.id == userID
          }
        }
      ],
      userData: [],
      auth: auth,
      showDownloadDialog: false,
      downloadUrl: '',
      downloadFileName: '',
      chainId: ''
    }
  },
  computed: {
    ...mapState({
      list: state => state.chain.chain_user_list,
      paging: state => state.chain.chain_user_paging
    })
  },
  watch: {
    '$store.state.computing.chainId': {
      deep: true,
      handler(val) {
        this.chainId = val
      }
    }
  },
  mounted() {
    this.chainId = this.$store.state.computing.chainId
    this.getList()
  },
  methods: {
    ...mapActions(['getUserLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        chainId: this.chainId,
        name: this.inputContent
      }
      this.getUserLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    handleChecked(row, col, cellValue) {
      localStorage.setItem('userID', JSON.stringify(row.id))
      this.$message.success('设置成功！')
      this.getList()
    },
    contractDown() {
      this.downloadUrl = `/cbaas-service/v1/mt/download/contract`
      this.downloadFileName = `medical_contract.7z`
      this.showDownloadDialog = true
    },
    handleSearch(val) {
      this.inputContent = val
      this.getList()
    },
    refresh() {
      this.inputContent = ''
      this.getList()
    },
    createData() {
      this.$refs.userDetail.handleOpen()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'block-chain-user',
  (
    --block-chain-user-card-item-body-background-color: #182141,
    --block-chain-user-card-item-hover-body-background-color: #2d3861,
    --block-chain-user-card-item-hover-border-color: #45c2ff
  ),
  (
    --block-chain-user-card-item-body-background-color: #eee,
    --block-chain-user-card-item-hover-body-background-color: #eeeeeecc,
    --block-chain-user-card-item-hover-border-color: #45c2ffcc
  )
);
.block-chain-user {
  @include adaptation(
    (
      --block-chain-user-unavaliable-height: 166px
    )
  );
  --block-chain-user-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--block-chain-user-unavaliable-height)
  );
  .btn-list-style {
    width: 100%;
  }

  .card-table-wrap {
    height: 100%;
    min-height: var(--block-chain-user-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--block-chain-user-min-height);
      }

      .card-table {
        height: 100%;
        min-height: var(--block-chain-user-min-height);
      }

      .card-item {
        .card-body {
          background-color: var(--block-chain-user-card-item-body-background-color);
          border-left-color: var(--block-chain-user-card-item-body-background-color);
          border-right-color: var(--block-chain-user-card-item-body-background-color);
          border-bottom-color: var(--block-chain-user-card-item-body-background-color);
        }

        &:hover {
          .card-body {
            background-color: var(--block-chain-user-card-item-hover-body-background-color);
            border-left-color: var(--block-chain-user-card-item-hover-border-color);
            border-right-color: var(--block-chain-user-card-item-hover-border-color);
            border-bottom-color: var(--block-chain-user-card-item-hover-border-color);
          }
        }
      }
    }
  }
}
</style>
